// extracted by mini-css-extract-plugin
module.exports = {"animatedSlider":"styles_animatedSlider__13Xy1","imageContainer":"styles_imageContainer__3vlcJ","slide":"styles_slide__1josu"};